import { ifAuthenticated } from '@/router/before'

export const adminProgramPages = [
  {
    path: '/admin/programs',
    name: 'AdminProgramsRoute',
    meta: {
      icon: ['fas', 'list-ul'],
      isDisplayInSidebar: true,
      group: 'Администратор',
      displayName: 'Программы',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AdminProgramsRoute" */ '@/views/admin-program/AdminProgramsRoute.vue'
      ),
  },
  {
    path: '/admin/applications',
    name: 'AdminApplicationsRoute',
    meta: {
      icon: ['fas', 'book'],
      isDisplayInSidebar: true,
      group: 'Администратор',
      displayName: 'Заявки',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AdminApplicationsRoute" */ '@/views/admin-program/AdminApplicationsRoute.vue'
      ),
  },
  {
    path: '/admin/documents',
    name: 'AdminDocumentsRoute',
    meta: {
      icon: ['fas', 'file'],
      isDisplayInSidebar: true,
      group: 'Администратор',
      displayName: 'Документы',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AdminDocumentsRoute" */ '@/views/admin-program/AdminDocumentsRoute.vue'
      ),
  },
  {
    path: '/admin/dashboards',
    name: 'AdminDashboardsRoute',
    meta: {
      icon: ['fas', 'chart-pie'],
      isDisplayInSidebar: true,
      group: 'Администратор',
      displayName: 'Аналитика',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AdminProgramsRoute" */ '@/views/admin-program/AdminDashboardsRoute.vue'
      ),
  },
]
